<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="optionLegalQuality"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :placeholder="placeholder"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="legalQualities.loading"
          :style="{ opacity: legalQualities.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay coincidencias para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { legalQualities } from '@/febos/aduanas/batches/store/getters';
import { fetchLegalQualities } from '@/febos/aduanas/batches/store/actions';

export default {
  computed: {
    ...mapGetters('batches', {
      legalQualities: legalQualities.name
    }),
    optionSelected() {
      const findOption = this.legalQualities.list
        .find((option) => option.value === this.value);
      if (findOption) {
        return { ...findOption, label: `${findOption?.value} - ${findOption?.label}` };
      }
      return null;
    },
    optionLegalQuality() {
      return this.legalQualities.list.map((legalQuality) => ({
        label: `${legalQuality.value} - ${legalQuality.label}`,
        id: legalQuality.id,
        value: legalQuality.value
      })).sort((a, b) => a.value - b.value);
    },
    isDisabled() {
      return this.disabled
        || !this.legalQualities.list.length
        || this.legalQualities.loading;
    }
  },
  methods: {
    ...mapActions('batches', {
      fetchLegalQualities: fetchLegalQualities.name
    }),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.legalQualities.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchLegalQualities();
  },
  props: {
    name: { type: String, required: true },
    placeholder: String,
    autocomplete: { type: Boolean, default: false },
    label: { type: String, default: 'Calidad jurídica' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};
</script>
